import { loadNativeModule, describeError } from './loadNativeModule';

export function getHardwareIdentity () {
    const DeviceInfo = loadNativeModule('@brightsign/deviceinfo');
    if (!DeviceInfo) return { available: false, reason: 'deviceinfo module unavailable' };

    try {
        const instance = new DeviceInfo();
        return {
            available: true,
            model: instance.model || null,
            family: instance.family || null,
            osVersion: instance.osVersion || null,
            bootVersion: instance.bootVersion || null,
            serialNumber: instance.serialNumber || null
        };
    } catch (error) {
        return { available: false, reason: `deviceinfo threw: ${describeError(error)}` };
    }
}
